// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const TabsContract = contract({
  name: "Tabs",
  description: "A small set of peer views within one surface (2–5 tabs). For primary nav use Side Menu/routing. For filters use a filter control, not tabs. Pick `variant=\"pill\"` for app chrome (settings panels, in-card tab strips). Pick `variant=\"underlined\"` for marketing/docs pages and browser-tab-style treatments.",
  import: "@gradeui/ui",
  aliases: ["tabs","tab strip","tab bar","tab view","tabbed interface","pageviewcontroller","react native tab view","underlined tabs","page tabs","segment switcher","simple tabs"],
  subcomponents: ["TabsList","TabsTrigger","TabsContent"],
  element: "div",
  subcomponentElements: {"TabsTrigger":"button"},
  composesWith: ["Card (tabs inside a card body)","Dialog","TooltipProvider (required for tooltip prop)"],
  styleDefaults: {"TabsList":"inline-flex items-center text-muted-foreground justify-center rounded-lg bg-muted","TabsContent":"mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"},
  props: {
  "defaultValue": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "value": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "orientation": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "size": {
      schema: z.enum(["sm", "md", "lg, default md"]).optional(),
      design: "knob",
      description: "t-shirt scale aligned with Button/ToggleGroup heights; cascades to every TabsTrigger via context so set it once on the list",
  },
  "variant": {
      schema: z.enum(["pill", "underlined, default pill"]).optional(),
      design: "knob",
      description: "`pill` is the shadcn chip-on-muted look; `underlined` is the minimal text + bottom-border treatment (formerly the separate SimpleTabs component, collapsed into Tabs in May 2026). Cascades to triggers.",
  },
  "tooltip": {
      schema: z.string().optional(),
      design: "content",
      description: "when set, wraps the trigger in the design-system Tooltip and auto-applies aria-label (useful for icon-only triggers); requires a TooltipProvider somewhere above the tabs",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "trigger shown but not selectable",
  },
  },
});
